<template>
    <ListenerGroupCast v-if="isListenerMobile" />
    <GroupCast v-else />
</template>

<script>
import GroupCast from './groupcast.vue'
import ListenerGroupCast from './ListenerGroupCast.vue'

export default {
    name: 'GroupCastEntry',
    components: {
        GroupCast,
        ListenerGroupCast
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
